import "./Cart.css";
import Item from "../Item/Item";
import {
  FinancialData,
  ItemDetailsData,
  RecommendedItem,
} from "../../../../Utils/DefinitionsInterfaces";
import { NFOLogoNoText } from "../../../../Assets/svgs";
import Subtotal from "../Subtotal/Subtotal";
import MultipleItems from "../Item/MultipleItems";
import { motion } from "framer-motion";
import { formatExamDate } from "../../../../Utils/dateFormatter";
import ReactGA from "react-ga4";

interface CartProps {
  stateDefaultItems: FinancialData[];
  stateCheckoutItems: ItemDetailsData[];
  stateRecommendedItems: RecommendedItem[];
  cbRemoveProduct: (itemId: number) => void;
  cbAddRecommended: (itemId: number) => void;
  cbHandlePaymentClick: () => void;
  // Coupon props
  couponState: {
    code: string;
    isApplied: boolean;
    isLoading: boolean;
    discountAmount: number;
    originalAmount: number;
    finalAmount: number;
    error: string;
  };
  couponInput: string;
  setCouponInput: (value: string) => void;
  handleApplyCoupon: (codeToApply?: string) => void;
  handleRemoveCoupon: () => void;
  isCouponEnabled: () => boolean;
}

const Cart = (props: CartProps) => {
  return (
    <div className="cart-parent-wrapper">
      {/* {props.stateRecommendedItems.map((e, i) => {
        return (
          <motion.div
            key={`recommended-item-${i}`}
            onClick={() => {
              props.cbAddRecommended(e.id);
            }}
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
            whileHover={{ scale: 1.01 }}
            style={{
              backgroundColor: "rgba(255, 255, 255, 1)",
              border: "solid 1px rgba(0,0,0,0.1)",
              width: "100%",
              padding: "20px 25px",
              borderRadius: "20px",
              marginBottom: "15px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                color: "rgba(36, 108, 193, 1)",
                alignSelf: "center",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                fontSize: "18px",
                marginBottom: "10px",
                backgroundColor: "rgba(36, 108, 193, 0.1)",
                width: "fit-content",
                padding: "10px 10px",
                borderRadius: "10px",
              }}
            >
              Recommended Items
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                className="text-wrapper-3"
                style={{
                  maxWidth: "250px",
                  color: "rgba(36, 108, 193, 1)",
                  alignSelf: "center",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <img
                  src={e.image}
                  alt={e.name}
                  style={{ width: "50px", height: "50px" }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {e.name}
                  <span
                    style={{
                      marginTop: "5px",
                      backgroundColor: "rgba(2, 59, 143, 0.1)",
                      color: "rgba(2, 59, 143, 1)",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "14px",
                      fontWeight: "500",
                      width: "fit-content",
                    }}
                  >
                    {Math.round(
                      ((e.base_price - e.selling_price) / e.base_price) * 100
                    )}
                    % OFF
                  </span>
                  {e.id === 3 && (
                    <div
                      style={{
                        color: "rgba(36, 108, 193, 0.8)",
                        fontSize: "14px",
                        fontWeight: "400",
                        fontFamily: "OggTextMedium",
                        marginTop: "5px",
                      }}
                    >
                      Exam Scheduled on : <br />
                      {e.examDate && `${formatExamDate(e.examDate)}`}
                    </div>
                  )}
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      textDecoration: "line-through",
                      marginRight: "10px",
                      color: "rgba(138, 138, 138, 0.8)",
                    }}
                    className="text-wrapper-3"
                  >
                    {"₹" + e.base_price}
                  </span>
                  <span className="text-wrapper-3">
                    {"₹" + e.selling_price}
                  </span>
                </div>
                <div
                  style={{
                    backgroundColor: " rgba(138, 138, 138, 0.1)",
                    border: "0.56px solid rgba(138, 138, 138, 0.1)",
                    padding: "8px",
                    marginTop: "10px",
                    color: "rgba(2, 59, 143, 1)",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    cursor: "pointer",
                    borderRadius: "10px",
                  }}
                >
                  + Add item
                </div>
              </div>
            </div>
          </motion.div>
        );
      })} */}

      <div className="cart">
        <div className="cart-child">
          <div className="cart-title">
            <div>
              <div className="text-wrapper-2">Purchase Details</div>
            </div>
            <img
              src={NFOLogoNoText}
              alt="NFO Logo"
              className="nfo-logo-details-section"
            />
          </div>

          {props.stateCheckoutItems.length > 1 ? (
            <MultipleItems
              stateCheckoutItems={props.stateCheckoutItems}
              cbRemoveProduct={props.cbRemoveProduct}
              key={`multiple-items-${props.stateCheckoutItems.length}`}
              isDefaultItem={true}
            />
          ) : (
            props.stateCheckoutItems.map((e, i) => (
              <Item
                stateCheckoutItem={e}
                cbRemoveProduct={props.cbRemoveProduct}
                key={`item-${i}`}
                isDefaultItem={true}
              />
            ))
          )}
        </div>
        <div className="button-container">
          {/* Coupon Section */}
          {props.isCouponEnabled() && (
            <div className="coupon-section" style={{ marginBottom: "20px" }}>
              <div
                className="coupon-input-wrapper"
                style={{ display: "flex", gap: "10px", marginBottom: "15px" }}
              >
                <input
                  type="text"
                  placeholder="Enter coupon code"
                  value={props.couponInput}
                  onChange={(e) =>
                    props.setCouponInput(e.target.value.toUpperCase())
                  }
                  style={{
                    flex: 1,
                    padding: "12px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontFamily: '"Cardo", Helvetica',
                    transition: "border-color 0.2s ease",
                  }}
                  disabled={props.couponState.isApplied}
                />
                <button
                  onClick={() => props.handleApplyCoupon()}
                  disabled={
                    props.couponState.isLoading || props.couponState.isApplied
                  }
                  style={{
                    padding: "12px 20px",
                    backgroundColor:
                      props.couponState.isLoading || props.couponState.isApplied
                        ? "#ccc"
                        : "white",
                    color: "#376CAA",
                    border: "none",
                    borderRadius: "8px",
                    cursor:
                      props.couponState.isLoading || props.couponState.isApplied
                        ? "not-allowed"
                        : "pointer",
                    fontSize: "16px",
                    fontWeight: 600,
                    fontFamily: '"Cardo", Helvetica',
                    whiteSpace: "nowrap",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.01)",
                  }}
                >
                  {props.couponState.isLoading ? "Applying..." : "Apply"}
                </button>
              </div>

              {/* Coupon Success State */}
              {props.couponState.isApplied && (
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #f8fbff 0%, #e8f2ff 100%)",
                    border: "1px solid #b3d4fc",
                    borderRadius: "12px",
                    padding: "16px",
                    marginBottom: "15px",
                    boxShadow: "0 2px 8px rgba(55, 108, 170, 0.1)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                          stroke="#10B981"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span
                      style={{
                        flex: 1,
                        color: "#376CAA",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: '"Cardo", Helvetica',
                      }}
                    >
                      Coupon <strong>"{props.couponState.code}"</strong> applied
                      successfully!
                    </span>
                    <button
                      onClick={props.handleRemoveCoupon}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "4px",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      title="Remove coupon"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M18 6L6 18M6 6L18 18"
                          stroke="#6B7280"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#374151",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: '"Cardo", Helvetica',
                      }}
                    >
                      Discount:
                    </span>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        fontFamily: '"Cardo", Helvetica',
                        color: "#10B981",
                      }}
                    >
                      -₹{props.couponState.discountAmount}
                    </span>
                  </div>
                </div>
              )}

              {/* Coupon Error State */}
              {props.couponState.error && (
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #fff8f8 0%, #ffe8e8 100%)",
                    border: "1px solid #ffcdd2",
                    borderRadius: "12px",
                    padding: "12px",
                    marginBottom: "15px",
                    boxShadow: "0 2px 8px rgba(244, 67, 54, 0.1)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                        stroke="#EF4444"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span
                      style={{
                        color: "#dc2626",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: '"Cardo", Helvetica',
                      }}
                    >
                      {props.couponState.error}
                    </span>
                  </div>
                </div>
              )}

              {/* Hardcoded Coupon Codes */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "rgba(44, 106, 177, 0.9)",
                    fontFamily: '"Cardo", Helvetica',
                    marginBottom: "5px",
                  }}
                >
                  Available Coupon Codes:
                </div>
                {["NEW5", "FINANCE12"].map((code) => (
                  <div
                    key={code}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      backgroundColor: "rgba(44, 106, 177, 0.1)",
                      border: "1px solid rgba(44, 106, 177, 0.2)",
                      borderRadius: "8px",
                      padding: "10px 12px",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        color: "rgba(44, 106, 177, 1)",
                        fontSize: "16px",
                        fontWeight: 600,
                        fontFamily: '"Cardo", Helvetica',
                        letterSpacing: "1px",
                      }}
                    >
                      {code}
                    </span>
                    <button
                      onClick={() => {
                        // Track ReactGA event
                        ReactGA.event({
                          category: "Copy_Coupon_Code",
                          action: "Apply_Coupon_From_List",
                          label: code,
                        });
                        // Auto-apply the coupon directly by passing the code
                        props.handleApplyCoupon(code);
                      }}
                      disabled={
                        props.couponState.isLoading ||
                        props.couponState.isApplied
                      }
                      style={{
                        padding: "6px 12px",
                        backgroundColor:
                          props.couponState.isLoading ||
                          props.couponState.isApplied
                            ? "#ccc"
                            : "white",
                        color: "#376CAA",
                        border: "none",
                        borderRadius: "6px",
                        cursor:
                          props.couponState.isLoading ||
                          props.couponState.isApplied
                            ? "not-allowed"
                            : "pointer",
                        fontSize: "12px",
                        fontWeight: 600,
                        fontFamily: '"Cardo", Helvetica',
                        whiteSpace: "nowrap",
                        transition: "all 0.2s ease",
                        opacity:
                          props.couponState.isLoading ||
                          props.couponState.isApplied
                            ? 0.6
                            : 1,
                      }}
                      onMouseEnter={(e) => {
                        if (
                          !props.couponState.isLoading &&
                          !props.couponState.isApplied
                        ) {
                          e.currentTarget.style.backgroundColor = "#f0f0f0";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (
                          !props.couponState.isLoading &&
                          !props.couponState.isApplied
                        ) {
                          e.currentTarget.style.backgroundColor = "white";
                        }
                      }}
                    >
                      {props.couponState.isLoading ? "Applying..." : "Apply"}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          <Subtotal
            stateCheckoutItems={props.stateCheckoutItems}
            cbHandlePaymentClick={props.cbHandlePaymentClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Cart;
